import React from 'react';
import {connect} from 'react-redux';
import {FOLLOWING_PICKS_TAB, FAVORITE_PICKS_TAB} from 'actions/ui';
import {getActivePicksTab} from 'selectors/ui';

import FollowingPicks from './FollowingPicks';
import FavoritePicks from './FavoritePicks';
import './style.scss';

const Picks = ({activeTab}) => (
  <div className="picks">
    {activeTab === FOLLOWING_PICKS_TAB && <FollowingPicks />}
    {activeTab === FAVORITE_PICKS_TAB && <FavoritePicks />}
  </div>
);

export default connect(state => ({
  activeTab: getActivePicksTab(state),
}))(Picks);
